import { jsx as _jsx } from "react/jsx-runtime";
export const QUARTZ_TRELLIS_LAYOUT_CONTAINER_CLASS = 'quartz-trellis-layout-container';
export const QUARTZ_TRELLIS_BLOCK_START_GLOBAL_SHELL_CLASS = 'quartz-trellis-block-start-global-shell';
export const QUARTZ_TRELLIS_INLINE_START_GLOBAL_SHELL_CLASS = 'quartz-trellis-inline-start-global-shell';
export const QUARTZ_TRELLIS_PAGE_HEADER_CLASS = 'quartz-trellis-page-header';
export const QUARTZ_TRELLIS_INLINE_START_SIDE_PANEL_CLASS = 'quartz-trellis-inline-start-side-panel';
export const QUARTZ_TRELLIS_INLINE_END_SIDE_PANEL_CLASS = 'quartz-trellis-inline-end-side-panel';
export const QUARTZ_TRELLIS_MAIN_CONTENT_CONTAINER_CLASS = 'quartz-trellis-main-content-container';
export const QUARTZ_TRELLIS_MAIN_CONTENT_CLASS = 'quartz-trellis-main-content';
export default function TrellisPageLayoutStyles() {
  return /*#__PURE__*/_jsx("style", {
    dangerouslySetInnerHTML: {
      __html: `
      /* TODO: Tokenize media queries and values (https://github.com/HubSpotEngineering/trellis-issues/issues/479) */

      /* Layout Container Base */
      .${QUARTZ_TRELLIS_LAYOUT_CONTAINER_CLASS} {
        background-color: #333333;
        block-size: calc(100vh - var(--global-nav-height, 0px));
        display: grid;
        padding-block-end: 16px;
        padding-inline-end: 16px;

        grid-template-areas:
          'blockStartGlobalShell blockStartGlobalShell'
          'inlineStartGlobalShell mainContent';
        grid-template-columns: auto 1fr;
        grid-template-rows: auto 1fr;
      }

      /* Block Start Global Shell */
      .${QUARTZ_TRELLIS_BLOCK_START_GLOBAL_SHELL_CLASS} {
        grid-area: blockStartGlobalShell;
      }

      /* Inline Start Global Shell */
      .${QUARTZ_TRELLIS_INLINE_START_GLOBAL_SHELL_CLASS} {
        grid-area: inlineStartGlobalShell;
        overflow-y: hidden;
      }

      /* Page Header */
      .${QUARTZ_TRELLIS_PAGE_HEADER_CLASS} {
        flex-shrink: 0;
        padding-block-start: 24px;
        padding-inline: 24px;
      }

      /* Inline Start Side Panel */
      .${QUARTZ_TRELLIS_INLINE_START_SIDE_PANEL_CLASS} {
        background-color: #ffffff;
        border-radius: 16px;
        box-shadow: 0px 16px 32px 0px rgba(20, 20, 20, 0.08);
        grid-area: inlineStartSidePanel;
        margin-block-end: 0px;
        margin-block-start: 0px;
        margin-inline-end: 8px;
        overflow-y: auto;
      }

      /* Inline End Side Panel */
      .${QUARTZ_TRELLIS_INLINE_END_SIDE_PANEL_CLASS} {
        background-color: #ffffff;
        border-radius: 16px;
        box-shadow: 0px 16px 32px 0px rgba(20, 20, 20, 0.08);
        grid-area: inlineEndSidePanel;
        margin-block-start: 0px;
        margin-inline-start: 8px;
        overflow-y: auto;
      }

      /* Main Content Container */
      .${QUARTZ_TRELLIS_MAIN_CONTENT_CONTAINER_CLASS} {
        background-color: #ffffff;
        border-radius: 16px;
        box-shadow: 0px 1px 8px 0px rgba(20, 20, 20, 0.08);
        display: flex;
        flex-direction: column;
        grid-area: mainContent;
        overflow-y: auto;
      }

      /* Main Content */
      .${QUARTZ_TRELLIS_MAIN_CONTENT_CLASS} {
        padding-block-end: 24px;
        padding-inline-end: 24px;
        padding-inline-start: 24px;
      }
    `
    }
  });
}